import {immerable} from 'immer';

export default class TreeComponentModel {
  [immerable] = true;

  update(
    obj,
  ) {
    Object.keys(obj).forEach((key) => {
      if (this[key] !== undefined) {
        this[key] = obj[key];
      }
    });
  }

  _options;
  get options() {
    return this._options;
  }
  set options(options) {
    this._options = options;
  }

  _labelKey;
  get labelKey() {
    return this._labelKey;
  }
  set labelKey(labelKey) {
    this._labelKey = labelKey;
  }

  _activeKey;
  get activeKey() {
    return this._activeKey;
  }
  set activeKey(activeKey) {
    this._activeKey = activeKey;
  }

  _childrenKey;
  get childrenKey() {
    return this._childrenKey;
  }
  set childrenKey(childrenKey) {
    this._childrenKey = childrenKey;
  }

  _identificatorKey;
  get identificatorKey() {
    return this._identificatorKey;
  }
  set identificatorKey(identificatorKey) {
    this._identificatorKey = identificatorKey;
  }


  constructor(data) {
    const {
      options = [],
      labelKey = 'label',
      activeKey = 'active',
      childrenKey = 'children',
      identificatorKey = 'id',
    } = data;
    this.options = options;
    this.labelKey = labelKey;
    this.activeKey = activeKey;
    this.childrenKey = childrenKey;
    this.identificatorKey = identificatorKey;
  }
}
